import "./main.scss";
import home from './js/pages/home';

document.addEventListener('DOMContentLoaded', () => {
    home();
});